import React, { Fragment, ReactNode, useRef } from 'react';
import { DivSXProps } from 'tradevan-ui/@emotion/DivSX';
import { classCombine, generateRandomString } from 'tradevan-ui/consts';
import TbSingleRwd from './TbSingleRwd';
import TbSingleRwdTd from './TbSingleRwdTd';
import TbSingleRwdTh from './TbSingleRwdTh';

interface IformFiledBase {
  /** 必填 - 標題加上 * */
  required?: boolean;
  /** 標題 */
  title: ReactNode;
  /** 內容 */
  child: ReactNode;
  /** 是否出現該欄位 */
  show?: boolean;
}
interface IformField extends IformFiledBase {
  invisible?: never;
}

interface IformFieldInvisible extends Partial<IformFiledBase> {
  invisible?: boolean;
}

export type Ifields = IformField | IformFieldInvisible;

export interface IcfFormRow {
  rowProps?: DivSXProps;
  fields: Ifields[];
}

export interface EditFormRowsProps {
  /** 隱藏標題上必填符號 */
  hideRequiredSign?: boolean;
  rows: IcfFormRow[];
  hdFixed?: boolean;
}

const EditFormRows = (props: EditFormRowsProps) => {
  const { hideRequiredSign, rows, hdFixed } = props;

  const keyRef = useRef(generateRandomString());

  return (
    <>
      {rows.map((obj, idx) => {
        const anyShow = obj.fields
          .filter((v) => !v.invisible)
          .some((v) => {
            const { show = true } = v;
            return show;
          });
        return (
          anyShow && (
            <TbSingleRwd key={`${keyRef.current}${idx + 1}`} {...obj.rowProps}>
              {obj.fields.map((obj2, idx2) => {
                const { show = true, invisible = false } = obj2;
                return (
                  <Fragment key={`${keyRef.current}${idx + 1}${idx2 + 1}`}>
                    {show && (
                      <>
                        <TbSingleRwdTh
                          className={classCombine(invisible && 'invisible')}
                          {...{ hdFixed }}
                        >
                          {obj2.required && !hideRequiredSign && (
                            <span className="star">* </span>
                          )}
                          {obj2.title}
                        </TbSingleRwdTh>
                        <TbSingleRwdTd
                          className={classCombine(invisible && 'invisible')}
                        >
                          {obj2.child}
                        </TbSingleRwdTd>
                      </>
                    )}
                  </Fragment>
                );
              })}
            </TbSingleRwd>
          )
        );
      })}
    </>
  );
};

export default EditFormRows;
